import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { TStep3Branch } from '../../../types';
import { addIcon, editt, trash } from '../../../assets/images/dashboard-business';
import Button2 from '../../global/Button2';
import Dropdown from '../../../common/dropdown/Dropdown';
import styles from './BusinessAddress.module.css';
import { setInLocalStorage, setInLocalStorageLtd } from '../../../utils/setRegInfoInLocalStorage';
import AddressSavedModal from './AddressSavedModal';
import DeleteModal from './DeleteModal';
import EditAddressModal from './EditAddressModal';
type TProps = {
  branches: TStep3Branch[];
  setDisplay: React.Dispatch<React.SetStateAction<number>>;
  setCurrentBranch: React.Dispatch<React.SetStateAction<number>>;
  currentBranch: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  states: any[];
  nearestSterlingStates: any[];
  lgaLoading: boolean;
  branchLoading: boolean;
  setBranches: React.Dispatch<React.SetStateAction<TStep3Branch[]>>;
};
const AddedBusinessAddress = ({
  branches,
  setCurrentBranch,
  branchLoading,
  lgaLoading,
  setBranches,
  nearestSterlingStates,
  states,
  setDisplay,
  setStep,
}: TProps) => {
  const [editting, setEditting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditSuccessModal, setShowEditSuccessModal] = useState(false);

  const [branchIndex, setBranchIndex] = useState(Infinity);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [branchesRecord, setBranchesRecord] = useState(branches);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const observedDiv: any = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      if (observedDiv && observedDiv.current.offsetWidth !== width) {
        setWidth(observedDiv.current.offsetWidth);
      }
      if (observedDiv && observedDiv.current.offsetHeight !== height) {
        setHeight(observedDiv.current.offsetHeight);
      }
    });
    resizeObserver.observe(observedDiv.current);

    return function cleanup() {
      resizeObserver.disconnect();
    };
  }, [observedDiv.current]);

  return (
    <div>
      <div className='font-[500] text-[16px] text-[#028789] mt-5 mb-4'>Added Address</div>

      <div className='mb-[100px]'>
        <div
          className={[
            'overflow-x-auto whitespace-nowrap overflow-y-visible',
            styles.hideScroll,
          ].join(' ')}
          style={{ height: `${height + 500}px`, minHeight: '300px' }}
        >
          <table className='bg-[#FAFAFA] overflow-visible' ref={observedDiv}>
            <thead className=''>
              <tr className='text-xs h-[50px] mb-4 bg-[#CDD8EA] pr-2'>
                <th className='mr-2'>{''}</th>
                <th>NUMBER & STREET</th>
                <th>STATE</th>
                <th>LGA</th>
                <th>TOWN</th>
                <th>BANK BRANCH</th>
                <th>ACTION</th>
              </tr>
            </thead>

            <tbody className='mt-4'>
              {[...branchesRecord]?.map((branch, index) => (
                <tr
                  key={branch?.streetName + branch?.streetNumber}
                  className='text-xs border-2 border-[#CDD8EA] py-2 box-content'
                >
                  <td data-label='' className='pr-[30px] pl-3 py-3'>
                    <div className='border-2 py-1 px-2 border-[#768396]'>{index + 1}</div>
                  </td>
                  <td data-label={`NUMBER & STREET`} className={['min-w-[150px]'].join(' ')}>
                    <input
                      className='w-[30%] h-full bg-[#FAFAFA] outline-none '
                      value={branch?.streetNumber}
                      placeholder={'#'}
                      readOnly={true}
                    />
                    <input
                      className='w-[70%] h-full bg-[#FAFAFA] outline-none '
                      value={branch?.streetName}
                      placeholder={'#'}
                      readOnly={true}
                    />
                  </td>
                  <td data-label='STATE' className='pr-[30px]'>
                    {branch?.selectedState}
                  </td>
                  <td data-label='LGA' className={'pr-[30px]'}>
                    {branch?.selectedLga}
                  </td>
                  <td data-label='TOWN' className='pr-[30px]'>
                    {branch?.nearestSterlingState?.value}
                  </td>

                  <td data-label='BANK BRANCH' className='pr-[30px] text-[11px]'>
                    {branch?.nearestSterlingBranch}
                  </td>
                  <td data-label='ACTIONS' className='min-w-[80px]'>
                    <div className='flex gap-1 cursor-pointer items-center font-[500]'>
                      <div>
                        <img
                          src={editt}
                          onClick={() => {
                            setBranchIndex(index);
                            setShowEditModal(true);
                          }}
                        />
                      </div>
                      {/* )} */}
                      <img
                        src={trash}
                        onClick={() => {
                          setShowDeleteModal(true);
                          setBranchIndex(index);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={['flex justify-center flex-col md:w-full mx-auto mt-[-400px]'].join(' ')}>
          <div className='flex justify-between  items-center'>
            <Button2
              className='px-2 md:px-5 !py-[10px] text-[11px] text-white border-[0px] rounded-[6px] '
              size='sm'
              underline={false}
              theme='primary'
              onClick={() => setStep((prev) => prev + 1)}
            >
              CONTINUE
            </Button2>
            <Button2
              // disabled={disabled}
              type='submit'
              theme='tertiary'
              className='!px-2 !gap-1  md:px-3 py-[10px] text-[11px] inline-block !rounded-[6px]'
              size='sm'
              icon={addIcon}
              underline={false}
              onClick={(e) => {
                e.preventDefault();
                setCurrentBranch(branches?.length + 1);
                setDisplay(0);
              }}
            >
              ADD NEW BRANCH
            </Button2>
          </div>
        </div>
      </div>

      <AddressSavedModal
        setShowSuccessModal={setShowSuccessModal}
        showSuccessModal={showSuccessModal}
        description={`Address ${branchIndex + 1} is successfully editted`}
        handleClick={() => {
          setShowSuccessModal(false);
          setDisplay(1);
        }}
        bottomText={`Close`}
      />

      <EditAddressModal
        branchInfo={branches[branchIndex]}
        description='Edit branch address'
        branchLoading={branchLoading}
        lgaLoading={lgaLoading}
        nearestSterlingStates={nearestSterlingStates}
        states={states}
        showModal={showEditModal}
        showSuccessModal={showEditSuccessModal}
        setShowModal={setShowEditModal}
        setShowSuccessModal={setShowEditSuccessModal}
        branchIndex={branchIndex}
        branches={branches}
        setBranches={setBranches}
        updateBranchesInTable={setBranchesRecord}
      />

      <DeleteModal
        description='Are you sure you want to delete this branch'
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        deleteFn={() => {
          const updatedBranch = branchesRecord?.filter((branch, index) => {
            if (branchIndex !== index) {
              return branch;
            }
          });

          setBranchesRecord(updatedBranch);
          setBranches(updatedBranch);
          setInLocalStorageLtd({ prop: 'branches-ltd', value: updatedBranch });
        }}
      />
    </div>
  );
};

export default AddedBusinessAddress;
